import { findIntegrationByProviderInEntities } from '@vy/services';
import { BaseIntegrationEntity, NetSuiteProductEntity, INTEGRATION_PROVIDERS } from '@vy/types';
import { Optional, replaceInIndex, now, isNullOrUndefined } from '@vy/utils';
import { ProductErpForm } from '../erp-product-settings-accordion-types/product-erp-form-schema';

export function getProductErpFormDefaultValues(
  integrationEntities: BaseIntegrationEntity[],
): Optional<ProductErpForm> {
  const netSuiteIntegrationEntity = findIntegrationByProviderInEntities<NetSuiteProductEntity>(
    integrationEntities,
    INTEGRATION_PROVIDERS.netSuite,
  );

  if (isNullOrUndefined(netSuiteIntegrationEntity)) {
    return;
  }

  return {
    product: [
      {
        integrationProvider: netSuiteIntegrationEntity.integrationProvider,
        integrationExternalId: netSuiteIntegrationEntity.integrationExternalId,
        metadata: {
          name: netSuiteIntegrationEntity.metadata.name,
        },
      },
    ],
    classMetadata: netSuiteIntegrationEntity.metadata.classMetadata ?? null,
  };
}

export function mapFormValuesToIntegrationEntity({
  product,
  classMetadata,
}: ProductErpForm): Optional<NetSuiteProductEntity> {
  const netSuiteIntegrationEntity = product?.at(0);

  if (isNullOrUndefined(netSuiteIntegrationEntity)) {
    return null;
  }

  const response: NetSuiteProductEntity = {
    updatedAt: now(),
    integrationProvider: netSuiteIntegrationEntity.integrationProvider,
    integrationExternalId: netSuiteIntegrationEntity.integrationExternalId,
    syncStatus: 'Synced',
    metadata: {
      name: netSuiteIntegrationEntity.metadata.name,
      classMetadata,
    },
  };

  return response;
}

export function buildUpdateLineItemIntegrationEntitiesPayload(
  integrationEntities: BaseIntegrationEntity[],
  netSuiteIntegrationEntityIndex: number,
  netSuiteIntegrationEntity: Optional<NetSuiteProductEntity>,
): BaseIntegrationEntity[] {
  if (netSuiteIntegrationEntityIndex === -1) {
    if (isNullOrUndefined(netSuiteIntegrationEntity)) {
      return integrationEntities;
    }

    return [...integrationEntities, netSuiteIntegrationEntity];
  }

  if (isNullOrUndefined(netSuiteIntegrationEntity)) {
    return integrationEntities.filter(
      (entity) => entity.integrationProvider !== INTEGRATION_PROVIDERS.netSuite,
    );
  }

  return replaceInIndex(integrationEntities, netSuiteIntegrationEntityIndex, netSuiteIntegrationEntity);
}
